import BoxImage from "@components/BoxImage";
import ButtonContainer from "@components/ButtonContainer";
import { AwardCategory } from "@enums/awardCategory";
import { awardCategoryMap } from "@helpers/award.helper";
import { IAwardDB } from "@interfaces/award";
import { ReactElement } from "react";
import { Col } from "reactstrap";

interface IDetailForm {
  data: IAwardDB;
}

const DetailForm = ({ data }: IDetailForm): ReactElement => (
  <form className="form">
    <Col md={7}>
      <div className="form__form-group">
        <span className="form__form-group-label">Year</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.year} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Category</span>
        <div className="form__form-group-field">
          <input
            type="text"
            value={awardCategoryMap[data?.category]}
            disabled
          />
        </div>
      </div>

      {data?.category === AwardCategory.WiseArtsChoice ? (
        <>
          <div className="form__form-group">
            <span className="form__form-group-label">Artist</span>
            <div className="form__form-group-field">
              <input value={data?.artist.artistName} disabled />
            </div>
          </div>

          <div className="form__form-group">
            <span className="form__form-group-label">Summary</span>
            <div className="form__form-group-field">
              <textarea value={data?.summary} disabled />
            </div>
          </div>

          <div className="form__form-group">
            <span className="form__form-group-label">Description</span>
            <div className="form__form-group-field">
              <textarea value={data?.description} disabled />
            </div>
          </div>
        </>
      ) : (
        <ButtonContainer />
      )}
    </Col>

    {data?.category === AwardCategory.WiseArtsChoice && (
      <>
        <Col md={5}>
          {data?.imageUrl && (
            <BoxImage urlImage={data?.imageUrl} title="Image" />
          )}
        </Col>

        <ButtonContainer />
      </>
    )}
  </form>
);

export default DetailForm;
